import { render, staticRenderFns } from "./GalleryFolder.vue?vue&type=template&id=30ae90e6&scoped=true"
import script from "./GalleryFolder.vue?vue&type=script&lang=js"
export * from "./GalleryFolder.vue?vue&type=script&lang=js"
import style0 from "./GalleryFolder.vue?vue&type=style&index=0&id=30ae90e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae90e6",
  null
  
)

export default component.exports